<gl-base-modal (closeModal)="close()" class="videoPopup">
  <h2 class="videoPopupHeader">
    {{ 'video_popup_header' | translate }}
  </h2>
  @if (isPl) {
    <div class="videoContainer">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/b8ENIX1xI_s?si=aqI0fS_1eD5_S5vM&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  }
  @if (!isPl) {
    <div class="videoContainer">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/_37XdB0YA7o?si=C8BM2GRNPvxOCGl2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  }
</gl-base-modal>
